import React from "react";
import styled from "styled-components/macro";

export const StyledContainer = styled.div`
	max-width: 500px;

	background: #ffffff;
	border: 1px solid #ebedee;
	border-radius: 8px;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	color: #575e68;

	display: flex;
	flex-direction: column;
	text-align: left;
	padding: 2rem;
	gap: 1rem;
	margin: auto;
	position: relative;
`;
export const StyledTitle = styled.h1`
	font-weight: 600;
	font-size: 32px;
	line-height: 48px;
	color: #3a5558;
	margin: 0.3rem 0;
`;

export const StyledButton = styled.button`
	background: ${(props) => (props.disabled ? "#E9D79D" : "#F1C232")};
	color: ${(props) => (props.disabled ? "#FCFCFD" : "#111111")};
	border: none;
	border-radius: 5px;
	padding: 0.6rem 1rem;

	font-weight: 600;
	font-size: 15px;
	line-height: 22px;
	cursor: pointer;
`;

export const StyledX = styled.button`
	${"" /* remove button design */}
	background: none;
	color: inherit;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;

	position: absolute;
	right: 1.5rem;
	top: 1.3rem;
`;

const ContentBox = ({ close, title, ...props }) => {
	return (
		<StyledContainer>
			{close ? (
				<StyledX type="button" onClick={close}>
					X
				</StyledX>
			) : null}
			<StyledTitle>{title}</StyledTitle>
			{props.children}
		</StyledContainer>
	);
};
export default ContentBox;
